
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const sections = [
  {
    icon: 'ri-file-text-line',
    title: '1. Genel Koşullar',
    content: `Bu web sitesine ("Microsoft Security Blog") erişerek ve kullanarak, aşağıda belirtilen kullanım koşullarını kabul etmiş sayılırsınız. Bu koşulları kabul etmiyorsanız, lütfen siteyi kullanmayınız. Site sahibi, bu koşulları önceden bildirimde bulunmaksızın güncelleme hakkını saklı tutar. Güncellenmiş koşullar, sitede yayınlandığı andan itibaren geçerli olur.`
  },
  {
    icon: 'ri-copyright-line',
    title: '2. Fikri Mülkiyet Hakları',
    content: `Bu sitede yayınlanan tüm makaleler, teknik içerikler, görseller, kod örnekleri, KQL sorguları, PowerShell scriptleri ve diğer materyaller aksi belirtilmedikçe site sahibine aittir. İçeriklerin izinsiz kopyalanması, çoğaltılması, dağıtılması veya ticari amaçla kullanılması yasaktır. Eğitim ve kişisel kullanım amacıyla kaynak göstererek alıntı yapılabilir.`
  },
  {
    icon: 'ri-open-source-line',
    title: '3. Açık Kaynak Projeler',
    content: `GitHub üzerinde paylaşılan açık kaynak projeler, ilgili depolarda belirtilen lisans koşullarına tabidir. Her projenin kendi lisans dosyasını (LICENSE) incelemeniz önerilir. Açık kaynak projelerin kullanımından doğabilecek sorunlardan site sahibi sorumlu tutulamaz. Projeler "olduğu gibi" (as-is) sunulmaktadır ve herhangi bir garanti verilmemektedir.`
  },
  {
    icon: 'ri-article-line',
    title: '4. İçerik Doğruluğu ve Sorumluluk',
    content: `Sitede yayınlanan teknik makaleler, Microsoft Sentinel, Intune ve Microsoft EDR gibi ürünlerle ilgili bilgi ve deneyim paylaşımı amacı taşımaktadır. İçerikler yayın tarihindeki bilgilere dayanmaktadır; Microsoft ürün güncellemeleri nedeniyle bazı bilgiler güncelliğini yitirebilir. Üretim ortamlarında uygulamadan önce resmi Microsoft dokümantasyonunu kontrol etmeniz önerilir. İçeriklerin uygulanmasından doğabilecek zararlardan site sahibi sorumlu tutulamaz.`
  },
  {
    icon: 'ri-chat-3-line',
    title: '5. Yorum ve Geri Bildirim',
    content: `Sitede yapılan yorumlar ve geri bildirimler, saygılı ve yapıcı bir dil ile yapılmalıdır. Hakaret, spam, yanıltıcı bilgi veya reklam içeren yorumlar kaldırılabilir. Site sahibi, uygunsuz içerikleri önceden bildirimde bulunmaksızın silme hakkını saklı tutar.`
  },
  {
    icon: 'ri-links-line',
    title: '6. Harici Bağlantılar',
    content: `Bu site, Microsoft dokümantasyonu, GitHub depoları ve diğer üçüncü taraf kaynaklara bağlantılar içerebilir. Bu harici sitelerin içeriklerinden, gizlilik politikalarından veya uygulamalarından site sahibi sorumlu değildir. Harici bağlantılara tıkladığınızda ilgili sitenin kendi kullanım koşullarına tabi olursunuz.`
  },
  {
    icon: 'ri-mail-send-line',
    title: '7. Bülten Aboneliği',
    content: `E-posta bültenine abone olarak, yeni makale bildirimleri ve güvenlik güncellemeleri almayı kabul edersiniz. Aboneliğinizi istediğiniz zaman iptal edebilirsiniz. E-posta adresiniz üçüncü taraflarla paylaşılmaz ve yalnızca bülten gönderimi amacıyla kullanılır.`
  },
  {
    icon: 'ri-shield-check-line',
    title: '8. Güvenlik ve Etik Kullanım',
    content: `Sitede paylaşılan güvenlik araçları, KQL sorguları ve otomasyon scriptleri yalnızca yasal ve etik amaçlarla kullanılmalıdır. Bu araçların kötü niyetli amaçlarla, yetkisiz erişim sağlamak veya sistemlere zarar vermek için kullanılması kesinlikle yasaktır. Araçların kötüye kullanımından doğacak her türlü yasal sorumluluk kullanıcıya aittir.`
  },
  {
    icon: 'ri-scales-3-line',
    title: '9. Uygulanacak Hukuk',
    content: `Bu kullanım koşulları Türkiye Cumhuriyeti yasalarına tabidir. Herhangi bir uyuşmazlık durumunda İstanbul mahkemeleri ve icra daireleri yetkilidir.`
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '10. İletişim',
    content: `Bu kullanım koşulları hakkında sorularınız veya talepleriniz için ozgur@ozgurcebi.com adresinden iletişime geçebilirsiniz.`
  }
];

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0F1419] via-[#1A2332] to-[#0F1419]" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30" />
        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)'
        }} />

        <div className="relative max-w-4xl mx-auto px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg mb-6">
              <i className="ri-file-shield-2-line text-blue-400 mr-2"></i>
              <span className="text-blue-400 text-sm font-medium">Yasal</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Kullanım Koşulları
            </h1>
            <p className="text-lg text-white/70 max-w-2xl mx-auto">
              Microsoft Security Blog web sitesini kullanmadan önce lütfen aşağıdaki koşulları dikkatlice okuyunuz.
            </p>
            <p className="text-sm text-white/40 mt-6">
              Son güncelleme: 1 Temmuz 2025
            </p>
          </motion.div>
        </div>
      </section>

      {/* İçerik */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-8">
          {/* Özet Kutusu */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-blue-50 border border-blue-100 rounded-xl p-6 mb-14"
          >
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 flex items-center justify-center mt-0.5">
                <i className="ri-information-line text-blue-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-blue-900 mb-1">Özet</h3>
                <p className="text-sm text-blue-800 leading-relaxed">
                  Bu site eğitim ve bilgi paylaşımı amaçlıdır. İçerikler &quot;olduğu gibi&quot; sunulur. Açık kaynak projeler kendi lisanslarına tabidir. Güvenlik araçlarını yalnızca yasal amaçlarla kullanınız.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Bölümler */}
          <div className="space-y-10">
            {sections.map((section, index) => (
              <motion.article
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
              >
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-lg flex-shrink-0 mt-0.5">
                    <i className={`${section.icon} text-gray-700 text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-3">
                      <a href={`#section-${index + 1}`} className="hover:text-blue-600 transition-colors">
                        {section.title}
                      </a>
                    </h4>
                    <p className="text-[15px] text-gray-600 leading-relaxed">
                      {section.content}
                    </p>
                  </div>
                </div>
                {index < sections.length - 1 && (
                  <div className="border-b border-gray-100 mt-10 ml-14"></div>
                )}
              </motion.article>
            ))}
          </div>

          {/* Alt Bilgi */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-16 pt-10 border-t border-gray-200"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <Link
                  to="/privacy"
                  className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer"
                >
                  <i className="ri-shield-keyhole-line mr-1"></i>
                  Gizlilik Politikası
                </Link>
                <span className="text-gray-300">|</span>
                <Link
                  to="/"
                  className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer"
                >
                  <i className="ri-home-4-line mr-1"></i>
                  Ana Sayfa
                </Link>
              </div>
              <p className="text-sm text-gray-400">
                &copy; 2025 Microsoft Security Blog
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsPage;
